// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Riqt","content":"styles_content__3xex6","checkbox":"styles_checkbox__2gZjr","checkboxLabel":"styles_checkboxLabel__gIm9h"};